import { http } from '@/lib/ats-https';

export type ScorecardSortBy =
  | 'activity_time'
  | 'stage'
  | 'rating'
  | 'created_at';
export type ScorecardSortOrder = 'asc' | 'desc';

export interface GetApplicationScorecardsParams {
  sort_by?: ScorecardSortBy;
  order?: ScorecardSortOrder;
}

const getApplicationScorecards = async (
  applicationId: string | number,
  statusFilter: string[],
  sortParams?: GetApplicationScorecardsParams
) => {
  const params: Record<string, unknown> = {
    view: 'application',
    limit: 100,
    include: ['transferred'],
    'filter_by[status][is]': statusFilter,
  };
  if (sortParams?.sort_by) {
    params.sort_by = sortParams.sort_by;
  }
  if (sortParams?.order) {
    params.order = sortParams.order;
  }
  const response = await http.get(
    `/ats_applications/${applicationId}/ats_scorecards`,
    { params }
  );
  // Normalize: handle both { scorecards, ... } and { data: { scorecards, ... } }
  return response?.data ?? response;
};

export const APPLICATION_SCORECARD_API = {
  getApplicationScorecards,
};
